<template>
  <div class="game" :id="containerId" v-if="downloaded" >
  <div id="containermenu"><div id="divmenu"><!--<img :src="require('@/game/assets/board/MapAliem.svg')">--></div></div>
  </div>
  <div style="background-color:#32443d;height:100vh;width:100vw;" class="placeholder" v-else>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      downloaded: false,
      gameInstance: null,
      containerId: 'game-container'
    }
  },
  async mounted() {
    const game = await import(/* webpackChunkName: "game" */ '@/game/game')
    this.downloaded = true
    this.$nextTick(() => {
      this.gameInstance = game.launch(this.containerId)
    })
  },
  destroyed() {
    this.gameInstance.destroy(false)
  }
}
</script>

<style lang="scss" scoped>
.placeholder {
  font-size: 2rem;
  font-family: 'Courier New', Courier, monospace;
}

.game{
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
}

#containermenu {
  width:100vw;
  height:100vh;
  position:absolute;
  display:flex;
  justify-content:center;
  align-items:center;
  display: none;
}

#divmenu {
  position:absolute;
  height:100px;
  width:100px;
  background-color:white;
}
</style>
